import { ProductTyreResource } from '@data/product-tyres/product-tyres.model';
import { FilterParams } from '@data/filtering/filtering.interface';
import { WholesalerResource } from '@data/wholesalers/wholesalers.model';
import { WorkshopResource } from '@data/workshop/workshop.model';
import { Id } from '@core/http/crud-model';

export interface StockResource {
  id: number;
  product_tyre: ProductTyreResource;
  dot: string;
  quantity: number;
  price: string;
  created_at: string;
  updated_at: string;
  stockable: Stockable;
}

export type StockFilterParams = FilterParams;
export type Stockable = WholesalerResource | WorkshopResource;

export class Stock {
  constructor(private resource: StockResource) {}

  getResource(): StockResource {
    return this.resource;
  }

  getProductTyre(): ProductTyreResource {
    return this.resource?.product_tyre;
  }

  getDot(): string {
    return this.resource?.dot;
  }

  getStockable(): Stockable {
    return this.resource?.stockable;
  }

  getPrice(): string {
    return this.resource?.price;
  }

  getQuantity(): number {
    return this.resource?.quantity;
  }

  getId(): Id {
    return this.resource?.id;
  }
}
